import React from "react";

import { CloseIcon as Close } from "@packages/ds";

import Input, { Error } from "ds/Input";

import { FormInputPropType } from "../type";

import * as S from "./styles";

const FormKeyValue = (config: FormInputPropType) => {
  const values: Array<{ name: string; value: string }> = config.value;

  const onAddItem = () => {
    const newValue = [...values, { name: "", value: "" }];
    config.onChange?.({
      target: {
        name: config.id,
        value: newValue
      }
    });
  };

  const onItemChange = (
    index: number,
    value: string,
    isName: boolean,
    isDelete?: boolean
  ) => {
    const item = values[index];
    isName ? (item.name = value) : (item.value = value);
    if ((item.name || item.value) && !isDelete) {
      values.splice(index, 1, item);
    } else if (isDelete) {
      values.splice(index, 1);
    }

    config.onChange?.({
      target: {
        name: config.id,
        value: [...values]
      }
    });
  };

  return (
    <div>
      <S.KeyValueTitle>{config.label}</S.KeyValueTitle>
      <div>
        {values.map((v, i) => (
          <S.KeyValuePair key={i} className="key-value-pairs">
            <Input
              className="key-value-field_name key-value-input"
              required
              placeholder="Field name"
              value={v.name}
              onChange={({ target }) => {
                onItemChange(i, target.value, true);
              }}
            />
            <Input
              className="key-value-field_value key-value-input"
              required
              placeholder="Field value"
              value={v.value}
              onChange={({ target }) => {
                onItemChange(i, target.value, false);
              }}
            />
            {!config.extra.preventDeleteKeyValue && (
              <S.CloseButton
                type="button"
                onClick={() => {
                  onItemChange(i, "", false, true);
                }}
              >
                <Close />
              </S.CloseButton>
            )}
          </S.KeyValuePair>
        ))}
      </div>
      <S.AddItemButton
        analyticId={config.extra.addLabel}
        onClick={onAddItem}
        variant="secondary"
      >
        {config.extra.addLabel}
      </S.AddItemButton>

      {config?.error && <Error>{config.error}</Error>}
    </div>
  );
};

export default FormKeyValue;
